import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import {__} from "~/ts/library/Translate";
import OperatorApplicationDialogTextareaButton
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaButton.vue";
import {computed, ref} from "vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import useTextareaComponent from "~/operatorApplication/vue/dialogs/dialog/textarea/useTextareaComponent";
import MyDialog from "~/cabinet/vue/interface/dialog/MyDialog.vue";
import startBot from "~/operatorApplication/ts/service/dialog/startBot";


import {defineComponent} from 'vue';
import Dictionary from "~/ts/library/Dictionary";

let lastSendedBots: Dictionary<string> = {};
const __default__ = defineComponent({
    name: "StartBotButton"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let {site, client} = useTextareaComponent();

let isCanRunBot = computed(() => {
    return OperatorAccountStore.checkAccess(OperatorAccountStore.data.value.accessRights.canStartBot, client.value.siteId);
});

let botsList = computed(() => {
    return (isCanRunBot.value ? site.value?.bots : null) ?? [];
});

let botsDialog = ref<{
    visible: boolean,
    model: {
        botId: string
    }
}>();

function showBotsDialog() {
    let botId = lastSendedBots[site.value.id];
    if (!botId || !botsList.value.find(bot => bot.id == botId)) {
        botId = botsList.value[0].id;
    }
    botsDialog.value = {
        visible: true,
        model: {
            botId
        }
    };
}

async function sendBot() {
    let result = await startBot(client.value.username, botsDialog.value.model.botId);

    if (result.isSuccess) {
        botsDialog.value = null;
    }
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_unref(botsList).length)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createVNode(OperatorApplicationDialogTextareaButton, {
          icon: "message-bot",
          tooltip: _unref(__)('Запустить бота'),
          onClick: showBotsDialog
        }, null, 8, ["tooltip"]),
        (_unref(botsDialog) && _unref(botsDialog).visible && _unref(botsList).length)
          ? (_openBlock(), _createBlock(MyDialog, {
              key: 0,
              visible: _unref(botsDialog).visible,
              "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(botsDialog).visible) = $event)),
              title: _unref(__)('Запустить бота'),
              "close-on-press-escape": "",
              onApply: sendBot
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form, { "label-position": "top" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(__)('Выберите бота')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(botsDialog).model.botId,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(botsDialog).model.botId) = $event)),
                          class: "w-100",
                          filterable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(botsList), (bot) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: bot.id,
                                value: bot.id,
                                label: bot.descr
                              }, null, 8, ["value", "label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["visible", "title"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})